import script from "./Favorites.vue?vue&type=script&setup=true&lang=js"
export * from "./Favorites.vue?vue&type=script&setup=true&lang=js"

import "./Favorites.vue?vue&type=style&index=0&id=073ccdf7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-073ccdf7"]])

export default __exports__